import { render, staticRenderFns } from "./PillSituation.vue?vue&type=template&id=78d813fa&scoped=true"
import script from "./PillSituation.vue?vue&type=script&lang=js"
export * from "./PillSituation.vue?vue&type=script&lang=js"
import style0 from "./PillSituation.vue?vue&type=style&index=0&id=78d813fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d813fa",
  null
  
)

export default component.exports